"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SHARED_EVENTS = void 0;
// Canonical cross-surface product-analytics event names.
//
// snake_case, fired identically on every surface and disambiguated only by the
// `surface` super-property (e.g. `generation_run` on web, photoshop, miro,
// revit alike). Importing from here — never inlining string literals at call
// sites — is what stops name drift, the #1 cause of unusable analytics data.
//
// These are the SHARED events all surfaces emit. Web-specific events
// (signup_succeeded, board_generation_run, …) stay in the web app's own EVENTS
// map, which re-exports these. See ADR-0016.
exports.SHARED_EVENTS = {
    PLUGIN_OPENED: 'plugin_opened',
    // The sign-in funnel. STARTED fires the instant the user picks a path from
    // the Gate (keyed by `intent` = 'sign_in' | 'sign_up' — the two Gate
    // buttons), before the browser opens; SIGNED_IN / SIGN_IN_FAILED /
    // SIGN_IN_CANCELLED are the three terminal outcomes and each carries the same
    // `intent` so the funnel splits new-user (sign_up) from returning (sign_in).
    // SIGN_IN_FAILED also carries `error_code` (see signInError.ts). NOTE: STARTED
    // and CANCELLED fire while signed-out — pre-identify — so they carry `surface`
    // (registered at boot) but NOT the identity super-props (is_internal_admin,
    // plan, …). Admin exclusion can't be applied to those two steps; the impact
    // is negligible (admins rarely fresh-sign-in on a plugin). See ADR-0026.
    SIGN_IN_STARTED: 'sign_in_started',
    SIGNED_IN: 'signed_in',
    SIGN_IN_FAILED: 'sign_in_failed',
    SIGN_IN_CANCELLED: 'sign_in_cancelled',
    ACCOUNT_SWITCHED: 'account_switched',
    TOOL_SELECTED: 'tool_selected',
    // Fired on successful submit (not click), keyed by node_def_id + tool_title
    // + surface. Surface-neutral — distinct from web's board_generation_run.
    GENERATION_RUN: 'generation_run',
    GENERATION_SUCCEEDED: 'generation_succeeded',
    GENERATION_FAILED: 'generation_failed',
    RESULT_INSERTED: 'result_inserted',
    // Get Tokens CTA at a Token Wall — impression + click, keyed by `variant`
    // (verify / get_tokens / team_depleted) + `surface`. See ADR-0020 and
    // CONTEXT.md "Plugin token gating & CTAs".
    GET_TOKENS_CTA_SHOWN: 'get_tokens_cta_shown',
    GET_TOKENS_CTA_CLICKED: 'get_tokens_cta_clicked',
    // Reliability signal (not a product event): a plugin's OS secure store
    // (UXP secureStorage → keychain / credential vault) was unreadable after
    // retries. Cross-plugin (photoshop / miro / revit), disambiguated by the
    // `surface` super-property. See ADR-0023.
    SECURE_STORE_UNAVAILABLE: 'secure_store_unavailable',
    // The user took the reset action offered after Retry failed: clear the stored
    // credentials and sign in fresh. `fully_cleared` says whether the deletes
    // themselves worked, which is the open question — a store too broken to read
    // may also be too broken to write, in which case reset cannot help and the
    // case belongs with support. See ADR-0023.
    SECURE_STORE_RESET: 'secure_store_reset',
};
